import { getAuthTokenAsync } from "src/store/common";
import * as api from "./api";
import { Survey, Meta } from "src/store/types";

interface ApiResponse {
  data: Survey[];
  meta: Meta;
}

// GET SURVEY LIST

export const fetchSurveyList = async (data: {
  page: number;
  limit: number;
  search?: string;
}): Promise<ApiResponse> => {
  const params: any = {
    page: data.page,
    limit: data.limit,
  };

  if (data.search && data.search.trim()) {
    params.search = data.search.trim();
  }

  const token = await getAuthTokenAsync();
  api.setHeaderAuthorization(token);

  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/survey`,
    params,
  );

  return response;
};

// DELETE SURVEY

export const deleteSurvey = async (id: number) => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);

  const response: any = await api.remove(
    `${process.env.REACT_APP_ADMIN_API_URL}/survey/${id}`,
  );

  return response;
};
